/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import {
	blackColour,
	brandingColourHeavy,
	greyWhite,
	phoneOnlyMaxWidth,
	tabletPortraitMinWidth,
	whiteColour
} from '../../../cssConstants';
import { useProgress } from './PublicProgressContext';
import { businessOwnerPageOnly, individualClientType, pageSteps } from './publicConstants';

const PublicPageSteps = ({ currentStep }: { currentStep: number }) => {
	const { clientTypeSelected } = useProgress();
	const [filteredSteps, setFilteredSteps] = useState(pageSteps);

	useEffect(() => {
		if (clientTypeSelected === individualClientType) {
			const indexToRemove = pageSteps.indexOf(businessOwnerPageOnly);
			if (indexToRemove !== -1) {
				pageSteps.splice(indexToRemove, 1);
			}
		} else if (!filteredSteps.includes(businessOwnerPageOnly)) {
			pageSteps.splice(2, 0, businessOwnerPageOnly);
		}
		setFilteredSteps(pageSteps);
	}, [clientTypeSelected]);

	return (
		<StepperContainer>
			<StepsWrapper>
				{filteredSteps.map((step, index) => (
					<React.Fragment key={index}>
						<Step $isFinished={index < currentStep}>{index + 1}</Step>
						{index < filteredSteps.length - 1 && <DottedLine />}
					</React.Fragment>
				))}
			</StepsWrapper>
			<StepLabels>
				{filteredSteps.map((step, index) => (
					<StepLabel key={index} $isFinished={index < currentStep}>
						{step}
					</StepLabel>
				))}
			</StepLabels>
		</StepperContainer>
	);
};

export default PublicPageSteps;

const StepperContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	margin: 20px 0px 30px 0px;

	@media (max-width: ${phoneOnlyMaxWidth}) {
		margin: 15px 0px 25px 0px; /* Reduced margin for smaller screens */
	}
`;

const StepsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap; /* Allow wrapping on smaller screens */

	@media (max-width: ${phoneOnlyMaxWidth}) {
		justify-content: space-between; /* Spread out steps on mobile */
	}
`;

const Step = styled.div<{ $isFinished: boolean }>`
	width: 40px;
	height: 40px;
	border: 2px solid ${({ $isFinished }) => ($isFinished ? 'transparent' : greyWhite)};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ $isFinished }) => ($isFinished ? brandingColourHeavy : greyWhite)};
	color: ${({ $isFinished }) => ($isFinished ? whiteColour : brandingColourHeavy)};
	font-weight: bold;
	transition:
		background-color 0.3s,
		color 0.3s;
	z-index: 1;

	@media (max-width: ${phoneOnlyMaxWidth}) {
		width: 30px; /* Smaller steps for mobile */
		height: 30px;
	}
`;

const DottedLine = styled.div`
	width: 20px;
	height: 2px;
	border-bottom: 2px dotted ${blackColour};
	margin: 0 10px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		width: 160px;
	}
`;

const StepLabels = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
	margin-top: 10px;
	flex-wrap: wrap;

	@media (max-width: ${phoneOnlyMaxWidth}) {
		display: none;
	}
`;

const StepLabel = styled.div<{ $isFinished: boolean }>`
	color: ${({ $isFinished }) => ($isFinished ? brandingColourHeavy : blackColour)};
	text-align: center;
	width: 200px; /* Ensures the label takes up enough space */

	@media (max-width: ${phoneOnlyMaxWidth}) {
		width: 100px; /* Reduced width for labels on smaller screens */
		font-size: 14px; /* Adjust font size for mobile */
	}
`;
